import { useMemo } from 'react';

import { useCartRecoveryMode } from 'features/cart/hooks/use-cart-recovery-mode';
import { useStoreContext } from 'features/store';

import { selectors, useAppSelector } from 'state/global-state';

import { BestPromotionRequest } from '../types';

export function useCartBestPromotionRequest(): BestPromotionRequest {
  const { mode } = useCartRecoveryMode();
  const legacyCartEntries = useAppSelector(selectors.ordering.selectCartEntries);
  const minimalCartEntries = useAppSelector(selectors.ordering.selectMinimalCartEntries);
  const { store } = useStoreContext();

  return useMemo(
    () => ({
      cartEntries: mode === 'minimal' ? minimalCartEntries : legacyCartEntries,
      storeId: store?.number ?? undefined,
      skipStoreDayPartHours: false,
    }),
    [legacyCartEntries, minimalCartEntries, mode, store?.number]
  );
}
